export enum AccesRole {
  ROLE_USER = 'ROLE_USER',
  ROLE_SUPPORT = 'ROLE_SUPPORT',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_SUPERADMIN = 'ROLE_SUPERADMIN',
}
